import { IService, IServiceMetadata, IServiceRequest } from "../models";

import { useGetServiceMetadata } from "../services/useGetServiceMetadata";
import { useLazyGetServiceRequestQuery } from "../services";

export interface IServiceRequestState {
    serviceRequest?: IServiceRequest,
    service?: IService,
    metadata?: IServiceMetadata
}

export const useServiceRequestFetchApi = ({ serviceId, requestId }: {
    requestId?: string, serviceId?: string
}) => {
    const { getServiceMetadata } = useGetServiceMetadata()
    const [getServiceRequest] = useLazyGetServiceRequestQuery();

    const getContextData = () => {
        if (requestId)
            return fetchServiceRequest(requestId)
        else
            return fetchServiceMetaData(serviceId)
    }

    const fetchServiceRequest = (requestId?: string, refetch?: boolean): Promise<IServiceRequestState> => {
        if (!requestId)
            return Promise.reject();

        return getServiceRequest(requestId, false)
            .unwrap()
            .then(serviceRequest => fetchServiceMetaData(serviceRequest.serviceId)
                .then(result => Promise.resolve({ ...result, serviceRequest })))
    }

    const fetchServiceMetaData = (serviceId?: string): Promise<IServiceRequestState> => {
        if (!serviceId)
            return Promise.reject();

        return getServiceMetadata(serviceId)
            .then(result => Promise.resolve({ metadata: result, service: result.service }))
    }

    const refetchRequest = () => {
        if (!requestId)
            return Promise.reject();

        return getServiceRequest(requestId, false)
            .unwrap()
    }

    return { getContextData, refetchRequest }
}